import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils.js';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(({ className, ...props }, ref) => {
  // Native file inputs render their own picker button. Text-input padding
  // (px-3 py-2) shoves that button out of vertical alignment inside the
  // frame, so for type=file we drop the wrapper padding and style the
  // ::file-selector-button to fill the frame height and sit flush left.
  const isFile = props.type === 'file';
  return (
    <input
      ref={ref}
      className={cn(
        'flex h-9 w-full rounded-md border border-[var(--app-divider-2)] bg-[var(--n-0)] text-body',
        'text-[var(--ink-700)] placeholder:text-[var(--fg-faint)]',
        'focus:outline-none focus-visible:border-[var(--brand-500)] focus-visible:ring-2 focus-visible:ring-[var(--brand-500)]/30',
        'disabled:cursor-not-allowed disabled:opacity-50',
        isFile
          ? 'cursor-pointer py-0 pl-0 pr-3 text-[var(--fg-2)] file:mr-3 file:h-full file:cursor-pointer file:border-0 file:border-r file:border-[var(--app-divider-2)] file:bg-[var(--app-surface)] file:px-3 file:text-body file:font-medium file:text-[var(--ink-700)]'
          : 'px-3 py-2',
        className,
      )}
      {...props}
    />
  );
});
Input.displayName = 'Input';
